// extracted by mini-css-extract-plugin
export default {"loading":"AlertConfirm_loading__6SI6H","buttonAcept":"AlertConfirm_buttonAcept__45-UQ","buttonCancel":"AlertConfirm_buttonCancel__jQ+zG"};